<template>
  <div class="hyrox-wrapper">
    <div v-if="loading" class="text-center pa-4">
      <v-skeleton-loader type="image" height="100"></v-skeleton-loader>
    </div>

    <div v-else class="hyrox-banner elevation-4" @click="openDialog">
      <div class="banner-bg"></div>
      <div class="banner-content d-flex align-center justify-space-between pa-4">
        <div class="d-flex align-center">
          <div class="icon-circle mr-4">
            <v-icon color="black" large>mdi-weight-lifter</v-icon>
          </div>
          <div>
            <h3 class="text-h6 font-weight-black yellow--text text--darken-2 mb-0">HYROX ST. GALLEN</h3>
            <div class="white--text caption font-weight-bold" v-if="myReservation">
              <v-icon x-small color="green" left>mdi-check-circle</v-icon>
              Du bist angemeldet!
            </div>
            <div class="white--text caption" v-else>Saison 25/26 - Jetzt Tickets sichern!</div>
          </div>
        </div>
        <v-btn icon dark small>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div v-if="myReservation" class="status-stripe success"></div>
      <div v-else class="status-stripe warning"></div>
    </div>

    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" style="z-index: 99999">
      <v-card class="hyrox-dialog-card d-flex flex-column">
        <v-toolbar color="black" dark flat class="flex-grow-0">
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="font-weight-black yellow--text text--darken-2 pl-0"> HYROX TICKETS </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 black-bg flex-grow-1 overflow-y-auto">
          <v-container class="pa-0" style="max-width: 800px; margin: 0 auto">
            <div v-if="!myReservation">
              <div class="pa-5 text-center">
                <h2 class="text-h5 font-weight-black white--text mb-3 text-uppercase">
                  well come FIT HYROX St.Gallen <span class="yellow--text text--darken-2">|</span> Saison 25/26
                </h2>

                <p class="grey--text text--lighten-1 body-2 mb-4" style="max-width: 600px; margin: 0 auto; line-height: 1.5">
                  Wir sind zurück für die zweite Runde! Wir sehen uns im Januar in den OLMA Messen St.Gallen – starte dein Jahr 2026 mit einem Knall!
                  💥
                  <br />Diesmal feiern wir den Sport des Fitness-Racings an ganzen 3 Tagen.
                </p>

                <div class="font-weight-black font-italic yellow--text text--darken-2 mb-5 text-h6">OUR SPORT IS HYROX.</div>

                <v-card color="grey darken-4" class="mb-2 rounded-lg elevation-2 border-highlight">
                  <v-card-text class="d-flex flex-column flex-sm-row justify-space-around align-center py-3">
                    <div class="d-flex align-center mb-2 mb-sm-0">
                      <v-icon color="#FBC02D" class="mr-2">mdi-calendar-range</v-icon>
                      <div class="text-left">
                        <div class="caption grey--text">Wann?</div>
                        <div class="font-weight-bold white--text">16.01. - 18.01.2026</div>
                      </div>
                    </div>

                    <div class="hidden-xs-only" style="width: 1px; height: 30px; background: rgba(255, 255, 255, 0.1)"></div>

                    <div class="d-flex align-center mt-2 mt-sm-0">
                      <v-icon color="#FBC02D" class="mr-2">mdi-map-marker</v-icon>
                      <div class="text-left">
                        <div class="caption grey--text">Wo?</div>
                        <div class="font-weight-bold white--text">OLMA Messen St.Gallen</div>
                        <div class="caption grey--text" style="font-size: 0.65rem !important">Splügenstrasse 12, 9008 St.Gallen</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <div class="mt-4">
                  <p class="grey--text lighten-1 mb-1 font-weight-medium">Wähle deinen Wettkampftag</p>
                  <small class="grey--text darken-2">Preise sind Totalpreise pro Team</small>
                </div>
              </div>

              <v-tabs v-model="activeTab" background-color="#121212" dark grow slider-color="#FBC02D" class="sticky-tabs elevation-2">
                <v-tab v-for="(day, index) in days" :key="index">
                  <div class="d-flex flex-column align-center py-2">
                    <span class="font-weight-bold">{{ day.label }}</span>
                    <span class="caption grey--text" style="line-height: 1">{{ day.date }}</span>
                  </div>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="activeTab" class="black-bg mt-2 transparent-items">
                <v-tab-item v-for="(day, index) in days" :key="index">
                  <div class="pa-3 pb-12">
                    <div v-if="getTicketsForDay(day.filterDay).length === 0" class="text-center pa-6 grey--text">
                      <v-icon large color="grey darken-3" class="mb-2">mdi-ticket-off</v-icon>
                      <br />Keine Tickets verfügbar.
                    </div>

                    <v-card
                      v-for="ticket in getTicketsForDay(day.filterDay)"
                      :key="ticket._id"
                      class="ticket-item mb-4 elevation-3"
                      :class="{ 'sold-out': ticket.isSoldOut }"
                      dark>
                      <div class="d-flex justify-space-between align-center pa-3 ticket-header">
                        <span class="font-weight-bold text-uppercase text-body-1">{{ ticket.division }}</span>
                        <div class="pl-2">
                          <v-chip x-small v-if="ticket.isSoldOut" color="red" class="font-weight-black">SOLD OUT</v-chip>
                          <v-chip x-small v-else color="green" outlined class="font-weight-bold" style="white-space: nowrap">
                            {{ ticket.remaining }} übrig
                          </v-chip>
                        </div>
                      </div>

                      <v-divider class="grey darken-3"></v-divider>

                      <div class="pa-3 d-flex flex-column flex-sm-row justify-space-between">
                        <div class="ticket-info mb-3 mb-sm-0 mr-sm-4">
                          <div class="caption grey--text text--lighten-1 mb-2 d-flex align-center">
                            <v-icon x-small color="#FBC02D" class="mr-1">mdi-account-group</v-icon>
                            <span class="font-weight-bold">{{ ticket.teamSize === 1 ? "Einzelstarter" : ticket.teamSize + "er Team" }}</span>
                          </div>
                          <div class="caption grey--text text-left" style="line-height: 1.4">
                            {{ ticket.description }}
                          </div>
                        </div>

                        <div class="d-flex flex-row flex-sm-column justify-space-between align-end text-right" style="min-width: 140px">
                          <div class="d-flex flex-column align-end mb-sm-2">
                            <span class="caption grey--text mb-0">Totalpreis</span>
                            <span class="text-h6 font-weight-black yellow--text text--darken-2" style="line-height: 1">
                              CHF {{ formatPrice(ticket.pricePerPersonChf * ticket.teamSize) }}
                            </span>
                          </div>

                          <v-btn
                            color="#FBC02D"
                            class="black--text font-weight-bold ml-3 ml-sm-0 mt-0 mt-sm-1"
                            @click="openConfirmDialog(ticket)"
                            :disabled="ticket.isSoldOut || reservationInProgress"
                            :loading="reservationInProgress"
                            elevation="0"
                            small>
                            Reservieren
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>

            <div v-else class="fill-height d-flex flex-column align-center justify-center pa-6" style="min-height: 80vh">
              <v-icon size="80" color="green" class="mb-4 animate__animated animate__bounceIn">mdi-check-circle</v-icon>
              <h2 class="text-h5 font-weight-bold white--text mb-2 text-center">Ticket reserviert!</h2>

              <v-card class="mt-4 pa-4 full-width elevation-6" color="#1e1e1e" dark style="max-width: 500px; width: 100%">
                <div class="d-flex justify-space-between align-start">
                  <div>
                    <div class="caption grey--text text-uppercase mb-1">Dein Ticket</div>
                    <div class="text-h6 font-weight-bold yellow--text text--darken-2" style="line-height: 1.2">
                      {{ reservedTicketDetail?.division || myReservation.content.ticketDivision || "Lade..." }}
                    </div>
                  </div>
                </div>

                <v-divider class="grey darken-3 my-4"></v-divider>

                <v-row dense>
                  <v-col cols="6">
                    <div class="caption grey--text">Datum</div>
                    <div class="font-weight-medium white--text">
                      {{ reservedTicketDetail?.day || "Event" }}, {{ reservedTicketDetail?.date || "2026" }}
                    </div>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <div class="caption grey--text">Preis (Total)</div>
                    <div class="font-weight-bold yellow--text text-h6">CHF {{ getDisplayPrice() }}</div>
                  </v-col>
                </v-row>

                <div class="mt-6 pa-3 rounded grey darken-4 d-flex align-start border-left-info">
                  <v-icon color="info" small class="mt-1 mr-2 flex-shrink-0">mdi-information</v-icon>
                  <span class="caption grey--text">
                    Vielen Dank für deine Reservierung! Wir senden dir in Kürze eine E-Mail mit einem Link. Über diesen Link kannst du dein Ticket
                    direkt bei Hyrox bezahlen und erhalten.
                    <br /><br />
                    <span class="grey--text text--darken-1">
                      Hinweis: Eine Stornierung ist online nicht möglich. Bitte melde dich bei Bedarf direkt im well come FIT Center.
                    </span>
                  </span>
                </div>
              </v-card>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="450" persistent style="z-index: 100000">
      <v-card dark color="#1e1e1e" class="rounded-lg">
        <v-card-title class="text-h6 font-weight-bold pb-2"> Reservierung bestätigen </v-card-title>

        <v-card-text v-if="ticketToReserve" class="pt-2">
          <p class="grey--text text--lighten-1 body-2">
            Du möchtest <strong>{{ ticketToReserve.division }}</strong> verbindlich für dein Team reservieren?
          </p>

          <div class="d-flex justify-space-between align-center grey darken-4 pa-4 rounded mt-2 mb-4">
            <span class="grey--text">Totalbetrag:</span>
            <span class="text-h5 font-weight-black yellow--text text--darken-2">
              CHF {{ formatPrice(ticketToReserve.pricePerPersonChf * ticketToReserve.teamSize) }}*
            </span>
          </div>

          <div class="pa-3 rounded" style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1)">
            <div class="d-flex align-center mb-2">
              <v-icon small color="#FBC02D" class="mr-2">mdi-information-outline</v-icon>
              <span class="font-weight-bold white--text caption text-uppercase">Wichtige Hinweise</span>
            </div>
            <ul class="caption grey--text text--lighten-1 pl-4" style="line-height: 1.5">
              <li class="mb-1">
                <strong>Ablauf:</strong> Wir senden dir einen Link per E-Mail. Die finale Buchung und Bezahlung erfolgt anschliessend direkt über
                HYROX.
              </li>
              <li class="mb-1">
                <strong>Preise:</strong> *Alle Preisangaben sind ohne Gewähr. Es gelten die aktuellen Preise von HYROX zum Zeitpunkt der Buchung.
              </li>
              <li><strong>Storno:</strong> Eine Online-Stornierung ist nicht möglich. Bitte wende dich bei Bedarf direkt an das Center-Personal.</li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions class="pb-4 px-4 pt-2">
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click="confirmDialog = false" :disabled="reservationInProgress"> Abbrechen </v-btn>
          <v-btn color="#FBC02D" class="black--text font-weight-bold px-4" @click="executeReservation" :loading="reservationInProgress" elevation="0">
            Verbindlich<br />reservieren
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api"

export default {
  name: "HyroxReservation",
  data() {
    return {
      loading: true,
      dialog: false,
      confirmDialog: false,
      ticketToReserve: null,
      reservationInProgress: false,
      tickets: [],
      myReservation: null,
      activeTab: 0,
      days: [
        { label: "Freitag", date: "16.01.", filterDay: "Friday" },
        { label: "Samstag", date: "17.01.", filterDay: "Saturday" },
        { label: "Sonntag", date: "18.01.", filterDay: "Sunday" },
      ],
    }
  },
  computed: {
    reservedTicketDetail() {
      if (!this.myReservation || !this.tickets.length) return null
      return this.tickets.find((t) => t._id === this.myReservation.content.ticketId)
    },
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    formatPrice(val) {
      if (!val && val !== 0) return "0.00"
      return parseFloat(val).toFixed(2)
    },
    getDisplayPrice() {
      if (this.myReservation && this.myReservation.content && this.myReservation.content.ticketPrice) {
        return this.formatPrice(this.myReservation.content.ticketPrice)
      }
      if (this.reservedTicketDetail) {
        return this.formatPrice(this.reservedTicketDetail.pricePerPersonChf * this.reservedTicketDetail.teamSize)
      }
      return "---"
    },
    async fetchData() {
      try {
        const res = await api.getHyroxTickets()
        this.tickets = res.tickets || []

        if (res.userReservation) {
          this.myReservation = {
            ...res.userReservation,
            content: res.userReservation.content || {
              ticketId: res.userReservation.ticketId,
              ticketPrice: res.userReservation.ticketPrice,
              ticketDivision: res.userReservation.ticketDivision,
              status: res.userReservation.status,
            },
          }
        } else {
          this.myReservation = null
        }
      } catch (e) {
        console.error("Hyrox fetch failed", e)
      } finally {
        this.loading = false
      }
    },
    getTicketsForDay(dayName) {
      return this.tickets.filter((t) => t.day === dayName)
    },
    openDialog() {
      this.dialog = true
    },
    openConfirmDialog(ticket) {
      this.ticketToReserve = ticket
      this.confirmDialog = true
    },
    async executeReservation() {
      if (!this.ticketToReserve) return

      this.reservationInProgress = true
      try {
        await api.reserveHyroxTicket(this.ticketToReserve._id)
        this.confirmDialog = false
        await this.fetchData()
        this.$toast.success("Erfolgreich reserviert!")
      } catch (e) {
        const msg = e.response?.data || "Fehler bei der Reservierung"
        this.$toast.error(msg)
      } finally {
        this.reservationInProgress = false
        this.ticketToReserve = null
      }
    },
  },
}
</script>

<style scoped>
.hyrox-wrapper {
  margin: 16px;
  margin-bottom: 24px;
}

/* BANNER STYLE */
.hyrox-banner {
  position: relative;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
  min-height: 80px;
}
.hyrox-banner:active {
  transform: scale(0.98);
}
.banner-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(135deg, #1a1a1a 0%, #000000 100%);
  z-index: 1;
}
.banner-content {
  position: relative;
  z-index: 2;
}
.icon-circle {
  width: 48px;
  height: 48px;
  background: #fbc02d;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(251, 192, 45, 0.4);
}
.status-stripe {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 2;
}
.status-stripe.warning {
  background: #fbc02d;
}
.status-stripe.success {
  background: #4caf50;
}

/* DIALOG & CARD STYLES */
.hyrox-dialog-card {
  background-color: #121212 !important;
  color: white;
}
.black-bg {
  background-color: #121212;
  min-height: 100%;
}
.sticky-tabs {
  position: sticky;
  top: 0;
  z-index: 10;
}
.transparent-items {
  background-color: transparent !important;
}

/* TICKET ITEM */
.ticket-item {
  background: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-left: 4px solid #fbc02d !important;
  transition: box-shadow 0.2s;
}
.ticket-item:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5) !important;
}
.ticket-item.sold-out {
  opacity: 0.6;
  filter: grayscale(1);
  border-left-color: #555 !important;
  pointer-events: none;
}
.ticket-header {
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.border-left-info {
  border-left: 3px solid #29b6f6;
}
.border-highlight {
  border: 1px solid rgba(251, 192, 45, 0.2); /* Dezent gelber Rand für Info Box */
}

::v-deep .v-toolbar__content {
  padding-right: 0;
}
::v-deep .v-tab {
  min-width: 80px;
  padding: 0 8px;
}
</style>
